import { UseMutationOptions } from '@tanstack/react-query';

import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import { SystemTemplateTogglePayload } from 'models/automation/SystemTemplates';
import API from 'services/API';

export const TOGGLE_SYSTEM_TEMPLATES_MUTATION_KEY = 'toggle-system-templates';

type UseToggleSystemTemplatesMutationArgs = SystemTemplateTogglePayload;

type ReactQueryMutationOptions<TContext = unknown> = Omit<
  UseMutationOptions<
    {},
    BaseErrorResponse,
    UseToggleSystemTemplatesMutationArgs,
    TContext
  >,
  'mutationFn' | 'mutationKey'
>;

const toggleSystemTemplates = ({
  ...payload
}: UseToggleSystemTemplatesMutationArgs) => {
  return API.patch<{}, BaseErrorResponse>(
    `/api/internal/automation/system-templates/toggle`,
    payload,
  );
};

const useToggleSystemTemplatesMutation = <TContext>({
  ...options
}: ReactQueryMutationOptions<TContext> = {}) => {
  return useAppMutation({
    mutationKey: [TOGGLE_SYSTEM_TEMPLATES_MUTATION_KEY],
    mutationFn: toggleSystemTemplates,
    ...options,
  });
};

export default useToggleSystemTemplatesMutation;
